export default {
  introduction: '简介',
  turnOff: '关闭',
  progress: '完成进度',
  Fold: '收起目录',
  Unfold: '展开目录',
  fillInAnswer: '请输入你的答案',
  qustionAnswer: '问答',
  qustionAnswer2: '问答题',
  singleChoice: '单选',
  multipleChoice: '多选',
  tit_sin: '拖拽单选',
  tit_mul: '拖拽多选',
  fillInBlank: '多行填空',
  fillInBlank2: '段落填空',
  fillInBlank3: '填空题',
  tureOrFalse: '判断',
  tureOrFalse2: '判断题',
  reference: '参',
  parsing: '问答解析',
  submit: '提交',
  correct: '正确',
  wrong: '错误',
  answerFeedback: '答案反馈',
  correctAnswer: '正确答案',
  questionParsing: '问题解析',
  beforeSubmit: '请先答题，再点击提交！',
  Finished: '已完成',
  Opening: '出品',
  EndVideo: '结束',
  IllustrationType: '图文',
  learnExam: '小测验',
  Enter: '进入',
  Deatil: '详情',
  collapse: '收起',
  contents: '目录',
  prevChapter: '上一章节',
  nextChapter: '下一章节',
  answerTrue: '回答正确',
  answerFalse: '回答错误',
  view: '查看',
  Matching: '配对单选',
  Matching2: '配对多选',
  scromLoadFailed: 'scorm课件加载失败',
  audioLoadFailed: '音频加载出错了',
  audioPlayback: '自动播放被拦截，请手动播放配音',
  finishedSubmit: '请答完题再提交',
  pageBack: '返回目录'
}
